import { Users } from "lucide-react"

import { cn } from "@/lib/utils"
import type { AlcanceDeGrupo } from "@/routes/holding/api"
import { t } from "@/lib/i18n"

/**
 * «ESTAS VIENDO UNA PARTE», dicho antes que el numero.
 *
 * El Holding era todo o nada: alcance sobre el tenant, o 403 y la seccion en
 * blanco. Ahora quien esta acotado a una sociedad ve EL TOTAL DEL GRUPO con el
 * detalle de las demas sumado bajo «otras sociedades». Eso resuelve el acceso y
 * crea un riesgo nuevo: una cifra acotada que no se anuncia se lee como si
 * fuera completa, y se firma.
 *
 * Por eso esto va arriba, con las advertencias, y no en un pie. Mismo criterio
 * que `Advertencias`: lo que cambia lo que significa el numero se lee ANTES.
 *
 * No es rojo. El total que se esta mirando ES correcto —esa es justamente la
 * regla de producto— y lo que esta recortado es el desglose. Pintarlo como
 * error diria algo falso, y ademas gastaria el rojo, que en esta seccion esta
 * reservado para el descuadre.
 *
 * Con alcance completo NO se pinta nada. Un aviso que aparece siempre deja de
 * leerse, y «ves el grupo entero» es el caso normal, no una noticia.
 */
export function AvisoDeAlcance({
  alcance,
  className,
}: {
  alcance?: AlcanceDeGrupo | null
  className?: string
}) {
  if (!alcance || alcance.completo) return null

  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded-md border bg-surface-sunken px-3 py-2",
        className,
      )}
      role="status"
    >
      <Users className="mt-px h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      <div className="min-w-0">
        <p className="text-2xs font-medium uppercase tracking-[0.06em] text-muted-foreground">
          {t("Ves el total del grupo, no el detalle de todas las sociedades")}</p>
        <p className="mt-0.5 max-w-[95ch] text-xs leading-[1.2rem] text-muted-foreground">
          {alcance.nota}
        </p>
      </div>
    </div>
  )
}
